import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ShareFat } from '@phosphor-icons/react'
import { isBefore, parseISO, startOfDay } from 'date-fns'
import React, { useEffect, useState } from 'react'
import { Button, Card, Container, Modal } from 'react-bootstrap'
import { CheckCircle } from 'react-bootstrap-icons'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import swal from 'sweetalert'
import AutocompleteClienteDefault from '../../components/autocomplete-cliente/autocomplete-clienteDefault'
import { CustomButton } from '../../components/CustomButton'
import { CustomPriceInput } from '../../components/CustomPriceInput'
import Navbar from '../../components/navbar/navbar'
import apinode from '../../services/apinode'
import { adaptValue } from '../../utils/adaptValue'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'
import '../pedido-editar/pedido-editar.css'
import './contas-editar.css'

function EditarContasReceber() {
  const [id, setId] = useState('')
  const { idConta } = useParams()
  const [idFornecedor, setIdFornecedor] = useState('')
  const [formaDePgto, setFormaDePgto] = useState('')
  const [numeroIdent, setNumeroIdent] = useState('')
  const [numeroDoc, setNumeroDoc] = useState('')
  const [vencimento, setVencimento] = useState('')
  const [valor, setValor] = useState('')
  const [situacao, setSituacao] = useState('')
  const [vencimentoOriginal, setVencimentoOriginal] = useState('')
  const [dataEmissao, setDataEmissao] = useState('')
  const [competencia, setCompetencia] = useState('')
  const [portador, setPortador] = useState('')
  const [categoria, setCategoria] = useState('')
  const [ocorrencia, setOcorrencia] = useState('')
  const [historicoConta, setHistoricoConta] = useState('')
  const [dataPgto, setDataPgto] = useState('')
  const [subCategoria, setSubCategoria] = useState('')
  const [idNfeEntrada, setIdNfeEntrada] = useState('')
  const [idPedidoCompra, setIdPedidoCompra] = useState('')
  const [pesRazao, setPesRazao] = useState('')
  const [pesCpf, setPesCPf] = useState('')
  const [pago, setPago] = useState(false)
  const conta = localStorage.idconta
  const navigate = useNavigate()
  const [categoriaOptions, setCategoriaOptions] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [razaoSocial, setRazaoSocial] = useState('')
  const [cpfCnpj, setCpfCnpj] = useState('')
  const [isSendAccountLoading, setIsSendAccountLoading] = useState(false)

  function handleKeyDown(event, campoAtual) {
    if (event.keyCode === 13) {
      event.preventDefault()
      // Faça alguma ação aqui com o valor do campoAtual
      // Por exemplo, envie o valor para o servidor ou faça alguma validação
      console.log(`Campo ${campoAtual}: ${event.target.value}`)
    }
  }

  useEffect(() => {
    // Fetch data for the dropdown from an API endpointHTTP://
    const fetchCategoriaOptions = async () => {
      try {
        const response = await apinode.get(
          `contas/categoria/${localStorage.idconta}`,
        )
        setCategoriaOptions(response.data) // Assuming response.data is an array of options
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchCategoriaOptions()
  }, [])

  const formatCpfCnpj = (value) => {
    if (!value) return ''

    const numbersOnly = value.replace(/[^\d]/g, '')

    if (numbersOnly.length <= 11) {
      return numbersOnly.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    } else {
      return numbersOnly.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5',
      )
    }
  }

  const handleNomeCliente = (nome) => {
    setPesRazao(nome)
    // Atualize o campo PES_RAZAO em editedConta com o nome do cliente selecionado
  }

  const handleOpenModal = (e) => {
    e.preventDefault()

    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    // e.preventDefault();

    setIsModalOpen(false)
  }

  const handleIdCliente = (id) => {
    setIdFornecedor(id)
  }

  const handleCpf = (cpf) => {
    setPesCPf(cpf)
    // setEditedConta((prevEditedConta) => ({
    //   ...prevEditedConta,
    //   ID_FORNECEDOR: id,
    // }));
    // Faça outras ações necessárias ao selecionar o cliente pelo CPF
  }

  const SalvarCliente = () => {
    const dados = {
      PES_RAZAO: razaoSocial,
      PES_CNPJ_CPF: cpfCnpj,
    }

    apinode
      .post(`/contasreceber/addcliente/${conta}`, dados)
      .then((response) => {
        console.log(response.data)
        swal('Sucesso', response.data.retorno, 'success')
      })
      .catch((error) => {
        console.error(error)
        swal('Erro', error.response.data.retorno, 'warning')
        // Handle the error appropriately here
      })
  }

  const handleBaixarConta = () => {
    const desejaBaixar = window.confirm('Deseja baixar as contas selecionadas?')

    if (desejaBaixar) {
      apinode
        .put(`/contasreceber/pgconta/${conta}?ids=${idConta}`, {})
        .then((response) => {
          console.log(response.data)
          swal('Sucesso', response.data.retorno, 'success')
          ListarContas()
        })
        .catch((error) => {
          console.error(error)
          swal('Erro', error.response.data.retorno, 'warning')
          // Handle the error appropriately here
        })
    } else {
      // Handle if the user clicks "Cancel" or closes the dialog without confirming
      // For example, you can show a message or perform other actions.
    }
  }

  async function enviarConta() {
    const dados = {
      ID_FORNCEDOR: idFornecedor,
      FORMA_DE_PGTO: formaDePgto,
      NUMERO_IDENT: numeroIdent,
      NUMERO_DOC: numeroDoc,
      VENCIMENTO: vencimento,
      VALOR: adaptValue(valor),
      SITUACAO: situacao,
      VENCIMENTO_ORIGINAL: vencimentoOriginal,
      DATA_EMISSAO: dataEmissao,
      COMPETENCIA: competencia,
      PORTADOR: portador,
      CATEGORIA: categoria,
      OCORRENCIA: ocorrencia,
      HISTORICO_CONTA: historicoConta,
      SUB_CATEGORIA: subCategoria,
      IDNFEENTRADA: idNfeEntrada || null,
      IDPEDIDOCOMPRA: idPedidoCompra || null,
      DATA_PGTO: dataPgto || null,
    }

    try {
      setIsSendAccountLoading(true)

      if (idConta) {
        await apinode.put(
          `/contasreceber/updateconta/${localStorage.idconta}/${idConta}`,
          dados,
        )
      } else {
        await apinode.post(
          `/contasreceber/addconta/${localStorage.idconta}`,
          dados,
        )
      }

      toast.success('Contas enviadas com sucesso!')
      navigate('/contas-a-receber')
    } catch (err) {
      sendErrorApiMessage(err, 'Erro ao enviar conta')
    } finally {
      setIsSendAccountLoading(false)
    }
  }

  function formatarData(data) {
    if (!data) return null // Trata o caso em que data é null
    const dataObj = new Date(data)
    const ano = dataObj.getFullYear()
    const mes = String(dataObj.getMonth() + 1).padStart(2, '0')
    const dia = String(dataObj.getDate()).padStart(2, '0')
    return `${ano}-${mes}-${dia}`
  }

  useEffect(() => {
    if (idConta) {
      ListarContas() // Chama a função para buscar as contas
    }
  }, [idConta]) // A dependência do useEffect é o idConta

  function ListarContas() {
    apinode
      .get(`contasreceber/contareceber/${idConta}/${localStorage.idconta}`, {})

      .then((retorno) => {
        console.log(retorno)
        if (retorno.status == 200) {
          // setRetApi(retorno.data)

          setId(retorno.data[0].ID)
          console.log(retorno.data[0].ID)
          setIdFornecedor(retorno.data[0].ID_FORNCEDOR)
          setPesRazao(retorno.data[0].PES_RAZAO)
          setFormaDePgto(retorno.data[0].FORMA_DE_PGTO)
          setNumeroIdent(retorno.data[0].NUMERO_IDENT)
          setNumeroDoc(retorno.data[0].NUMERO_DOC)
          setVencimento(formatarData(retorno.data[0].VENCIMENTO))
          setValor(
            retorno.data[0].VALOR.toLocaleString('pt-BR', {
              style: 'currency',
              currency: 'BRL',
            }),
          )
          console.log(retorno.data[0].VENCIMENTO_ORIGINAL)
          setSituacao(retorno.data[0].SITUACAO)
          setVencimentoOriginal(
            formatarData(retorno.data[0].VENCIMENTO_ORIGINAL),
          )
          setDataEmissao(formatarData(retorno.data[0].DATA_EMISSAO))
          setCompetencia(formatarData(retorno.data[0].COMPETENCIA))
          setPortador(retorno.data[0].PORTADOR)
          setCategoria(retorno.data[0].CATEGORIA)
          setOcorrencia(retorno.data[0].OCORRENCIA)
          setHistoricoConta(retorno.data[0].HISTORICO_CONTA)
          setIdNfeEntrada(retorno.data[0].IDNFEENTRADA)
          setIdPedidoCompra(retorno.data[0].IDPEDIDOCOMPRA)
          setPesRazao(retorno.data[0].PES_RAZAO)
          setPesCPf(retorno.data[0].PES_CNPJ_CPF)
          setDataPgto(formatarData(retorno.data[0].DATA_PGTO))

          if (retorno.data[0].SITUACAO === 'Pago') {
            setPago(true)
          }

          // setOutrasDespesas(retorno.data.OUTRASDESPESAS)
          // setTotal(retorno.data.TOTAL.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setAcrescimo(retorno.data.ACRESCIMO.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setDesconto(retorno.data.DESCONTO.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setFrete(retorno.data.FRETE.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setIcmsFrete(retorno.data.ICMSFRETE.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setBcIcms(retorno.data.BCICMS.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setValorIcms(retorno.data.VALORICMS.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setVlrBaseIcmsSt(retorno.data.VLRBASEICMSST.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setVlrIcmsSt(retorno.data.VLRICMSST.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setTotalProdutos(retorno.data.TOTAL_PRODUTOS.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setEmissorCodigoEstado(retorno.data.EMISSOR_CODIGOESTADO)
          // setCodificacaoFiscal(retorno.data.CODIFICACAOFISCAL)
          // setValorPis(retorno.data.VALORPIS.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setValorCofins(retorno.data.VALORCOFINS.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setValorIpi(retorno.data.VALORIPI.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setValorSeguro(retorno.data.VALORSEGURO.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))
          // setFreteIncluso(retorno.data.FRETEINCLUSO)
          // setValorIcmsSubIncluso(retorno.data.VALORICMSSUBINCLUSO)
          // setCustoSemDesconto(retorno.data.CUSTOSSEMDESCONTO)
          // setProdutos(retorno.data.itens)
          // setDuplicatas(retorno.data.duplicatas)
          // setTransportadoraNome(retorno.data.TRANSP_NOME)
          // setTransportadoraCnpj(retorno.data.TRANSP_CNPJ)
          // setTransportadoraEndereco(retorno.data.TRANSP_ENDERECO)
          // setTransportadoraInsc(retorno.data.TRANSP_INSC)
          // setTransportadoraCidade(retorno.data.TRANSP_CIDADE)
          // setTransportadoraPlaca(retorno.data.TRANSP_PLACA + ' - ' + retorno.data.TRANSP_UFPLACA)
          // setTransportadoraUf(retorno.data.TRANSP_UF)
          // setTransportadoraTipo(retorno.data.TRANSP_TIPO)
          // setPesoBruto(retorno.data.PESOTOTAL)
          // setAddCont(retorno.data.ADDCONT)
          // setCalcImp(retorno.data.CALCIMP)
        } else {
          alert('Erro ao processar... contate suporte!')
          console.log(retorno)
        }
      })
  }

  return (
    <>
      <Navbar />
      <Container
        className="mt-page"
        style={{
          display: 'flex',
          justifyContent: 'center',
          height: 'auto',
          minHeight: '100vh',
        }}
      >
        <Card
          style={{
            width: '50%',
          }}
        >
          <Card.Body className="row justify-content-center">
            <div
              className="mb-4 mt-2"
              style={{ flex: 1 }}
            >
              <div className="mb-4 mt-2 text-left">
                <h3>
                  <span className="text-primary h5">{pesRazao}</span>{' '}
                  {pago && (
                    <CheckCircle
                      className="text-success ms-2"
                      size={40}
                    />
                  )}
                </h3>
                <p className="text-muted mb-0 ">{pesCpf}</p>
              </div>

              <form>
                <div className="col-md-12 mb-3">
                  <label
                    htmlFor="CLIENTE"
                    className="form-label"
                  >
                    Cliente:
                  </label>
                  <AutocompleteClienteDefault
                    placeholder="Pesquisar cliente..."
                    onClickNome={handleNomeCliente}
                    onClickId={handleIdCliente}
                    onClickCpf={handleCpf}
                    value={pesRazao} // Passa o nome do cliente selecionado ao componente
                    className="form-control"
                  />
                </div>
                <div className="col-md-12 mb-3">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleOpenModal}
                  >
                    <FontAwesomeIcon icon={faPlusCircle} /> add cliente
                  </button>
                </div>

                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>ID</label>
                    <input
                      disabled
                      type="text"
                      className="form-control"
                      value={id}
                      onChange={(e) => setId(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Cod. Forncedor</label>
                    <input
                      type="text"
                      className="form-control"
                      value={idFornecedor}
                      onChange={(e) => setIdFornecedor(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Forma de Pgto</label>
                    <select
                      className="form-control"
                      style={{ border: '1px solid #ccc' }}
                      value={formaDePgto}
                      onChange={(e) => setFormaDePgto(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    >
                      <option value="">Não selecionado</option>{' '}
                      {/* Opção adicionada */}
                      <option value="cartao_credito">Cartão de Crédito</option>
                      <option value="cartao_debito">Cartão de Débito</option>
                      <option value="Boleto">Boleto Bancário</option>
                      <option value="transferencia">
                        Transferência Bancária
                      </option>
                      <option value="Dinheiro">Dinheiro</option>
                      <option value="cheque">Cheque</option>
                      <option value="pix">Pix</option>
                    </select>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Nº Indentificação</label>
                    <input
                      type="text"
                      className="form-control"
                      value={numeroIdent}
                      onChange={(e) => setNumeroIdent(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Nº Documento</label>
                    <input
                      type="text"
                      className="form-control"
                      value={numeroDoc}
                      onChange={(e) => setNumeroDoc(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Vencimento</label>
                    <input
                      type="date"
                      className="form-control"
                      value={vencimento}
                      onChange={(e) => setVencimento(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Valor</label>

                    <CustomPriceInput
                      value={valor}
                      onChange={(e) => setValor(e.target.value)}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Situação</label>
                    <select
                      className="form-control"
                      style={{ border: '1px solid #ccc' }}
                      value={situacao}
                      onChange={(e) => setSituacao(e.target.value)}
                    >
                      <option value="-1">--Não Selecionado--</option>
                      <option value="Em Aberto">Em Aberto</option>
                      <option value="Pago">Pago</option>
                      <option value="Aguardando Pagamento">
                        Aguardando Pagamento
                      </option>
                      <option value="Vencida">Vencida</option>
                      <option value="Cartorio">Cartorio</option>
                    </select>
                  </div>

                  <div className="col-md-4">
                    <label>Venc. original</label>
                    <input
                      type="date"
                      className="form-control"
                      value={vencimentoOriginal}
                      onChange={(e) => setVencimentoOriginal(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Emissao em:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dataEmissao}
                      onChange={(e) => setDataEmissao(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Competencia</label>
                    <input
                      type="date"
                      className="form-control"
                      value={competencia}
                      onChange={(e) => setCompetencia(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Portador</label>
                    <input
                      type="text"
                      className="form-control"
                      value={portador}
                      onChange={(e) => setPortador(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Categoria</label>
                    <select
                      className="form-control"
                      value={categoria}
                      onChange={(e) => setCategoria(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    >
                      <option value="">Selecione...</option>
                      {categoriaOptions.map((option, index) => (
                        <option
                          key={index}
                          value={option.CODIGO}
                        >
                          {option.DESCRICAO}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label>Ocorrencia</label>
                    <input
                      type="text"
                      className="form-control"
                      value={ocorrencia}
                      onChange={(e) => setOcorrencia(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-12">
                    <label>Obs</label>
                    <textarea
                      rows="5"
                      type="text"
                      className="form-control"
                      value={historicoConta}
                      onChange={(e) => setHistoricoConta(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Pago em:</label>
                    <input
                      type="date"
                      className="form-control"
                      value={dataPgto}
                      onChange={(e) => setDataPgto(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Sub Categoria</label>
                    <input
                      type="text"
                      className="form-control"
                      value={subCategoria}
                      onChange={(e) => setSubCategoria(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  <div className="col-md-4">
                    <label>Nfe</label>
                    <input
                      type="text"
                      className="form-control"
                      value={idNfeEntrada}
                      onChange={(e) => setIdNfeEntrada(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-4">
                    <label>Pedido Compra</label>
                    <input
                      type="text"
                      className="form-control"
                      value={idPedidoCompra}
                      onChange={(e) => setIdPedidoCompra(e.target.value)}
                      onKeyDown={(e) => handleKeyDown(e, 'Campo 1')}
                    />
                  </div>
                  {/* Adicione outros campos aqui, se necessário */}
                </div>
                <div className="d-grid">
                  <CustomButton
                    isLoading={isSendAccountLoading}
                    title="Enviar"
                    isLoadingText="Enviando..."
                    onClick={enviarConta}
                  >
                    <ShareFat
                      size={20}
                      weight="fill"
                    />
                  </CustomButton>
                </div>
              </form>
              {/* Grupo de botões */}
              <div className="mt-4 d-flex justify-content-between">
                <button
                  type="button"
                  className="btn btn-secondary mx-2"
                  onClick={handleBaixarConta}
                >
                  <i className="bi bi-download"></i> Baixar Conta
                </button>
                <button
                  type="button"
                  className="btn btn-secondary mx-2"
                >
                  <i className="bi bi-printer"></i> Imprimir Recibo
                </button>
                <button
                  type="button"
                  className="btn btn-secondary mx-2"
                >
                  <i className="bi bi-gear"></i> Alterar Andamento
                </button>
                <button
                  type="button"
                  className="btn btn-secondary mx-2"
                >
                  <i className="bi bi-pencil"></i> Adicionar Observações
                </button>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Container>

      <Modal
        show={isModalOpen}
        onHide={handleCloseModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Cadastrar Cliente</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">CPF/CNPJ</label>
            <input
              type="text"
              className="form-control"
              value={formatCpfCnpj(cpfCnpj)} // Aplicar a máscara aqui
              onChange={(e) => setCpfCnpj(e.target.value)}
            />
          </div>
          <div className="mb-3">
            <label className="form-label">Razão Social</label>
            <input
              type="text"
              className="form-control"
              value={razaoSocial}
              onChange={(e) => setRazaoSocial(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseModal}
          >
            Fechar
          </Button>
          <Button
            variant="primary"
            onClick={SalvarCliente}
          >
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default EditarContasReceber
